import type * as Types from '../../../../gql/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ReleaseGradesMutationVariables = Types.Exact<{
  input: Types.ReleaseGradesInput;
}>;


export type ReleaseGradesMutation = { __typename?: 'RootMutationType', releaseGrades: Array<{ __typename?: 'ClassroomAssignment', id: string, assignmentId: string, classroomId: string, gradesReleased?: boolean | null, gradesReleasedAt?: any | null }> };


export const ReleaseGradesDocument = gql`
    mutation ReleaseGrades($input: ReleaseGradesInput!) {
  releaseGrades(input: $input) {
    id
    assignmentId
    classroomId
    gradesReleased
    gradesReleasedAt
  }
}
    `;
export type ReleaseGradesMutationFn = Apollo.MutationFunction<ReleaseGradesMutation, ReleaseGradesMutationVariables>;

/**
 * __useReleaseGradesMutation__
 *
 * To run a mutation, you first call `useReleaseGradesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReleaseGradesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [releaseGradesMutation, { data, loading, error }] = useReleaseGradesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReleaseGradesMutation(baseOptions?: Apollo.MutationHookOptions<ReleaseGradesMutation, ReleaseGradesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReleaseGradesMutation, ReleaseGradesMutationVariables>(ReleaseGradesDocument, options);
      }
export type ReleaseGradesMutationHookResult = ReturnType<typeof useReleaseGradesMutation>;
export type ReleaseGradesMutationResult = Apollo.MutationResult<ReleaseGradesMutation>;
export type ReleaseGradesMutationOptions = Apollo.BaseMutationOptions<ReleaseGradesMutation, ReleaseGradesMutationVariables>;